import { graphql } from '../../../../graphql/generated';

export const UPDATE_FORM_MUTATION = graphql(`
  mutation UpdateForm($id: ID!, $input: FormInput!) {
    updateForm(id: $id, input: $input) {
      id
    }
  }
`);
